<template>
<b-container fluid>
  <div class="modal-body">
    <div class="rounded rounded-2 bg-light">
      <div style="display: flex;">
        <i class="fas fa-info-circle text-primary" style="font-size: 20px; margin-right: 12px;"></i>
        <div>
          <p class="mb-0 text-primary">
            This action will update the app/quiz id of {{propAppDetails.qbk_id ? "selected question" : "all questions"}} linked to the old app/quiz id.
          </p>
        </div>
      </div>
    </div>

    <!-- Old App/Quiz -->
    <div class="col-md-12 mt-2 mb-3">
      <h3>App/Quiz Name:&nbsp;{{propAppDetails.app_name}}</h3>
      <h3 v-if="propAppDetails.qbk_id">Question Id:&nbsp;{{propAppDetails.qbk_id}}</h3>
    </div>
    <div class="col-md-12 mb-3">
      <label>Current App Id</label>
      <input disabled v-model="propAppDetails.app_id" class="form-control"/>
      <label class="text-danger" v-if="errorMessage">{{ errorMessage }}</label>
    </div><!-- Old App/Quiz -->

    <!-- New App Id -->
    <div class="col-md-12 mb-3">
      <label>New App Id</label>
      <input v-model="vmAppFormData.app_id" placeholder="Manually Enter The New App Id" class="form-control"/>
      <label class="text-danger" v-if="errorMessage">{{ errorMessage }}</label>
    </div><!-- New App Id -->

    <button type="button" class="btn btn-primary" @click="quizBankEdit()">
      {{ cvSubmitBtn }}
    </button>
  </div>
  <b-toast
    v-model="showToast"
    name="Toast"
    :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
    :variant="toastVariant"
    :title="toastTitle"
  >
    <div v-html="toastMsg"></div>
  </b-toast>
</b-container>
</template>

<script>
import { QuizBanks } from "../../../FackApi/api/quizBank"
import ApiResponse from "../../../Utils/apiResponse.js"

export default {
  name: "ChangeAppidModal",
  props: {
    propAppDetails: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showEditAppIdModal: false,
      vmAppFormData: {},
      errorMessage: null,
      cvSubmitBtn: "Update",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Questions Migrated"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  methods: {
    async quizBankEdit () {
      if (!this.vmAppFormData?.app_id) {
        this.errorMessage = "App id is mandatory."
        return
      }
      else {
        this.errorMessage = null
      }

      let payload = {
        app_id: this.vmAppFormData.app_id,
        oldApp_id: this.propAppDetails.app_id,
        qbk_id: this.propAppDetails.qbk_id ? this.propAppDetails.qbk_id : "All"
      }

      try {
        let quizBankAddResp = await QuizBanks.quizBankEdit(this, payload)

        ApiResponse.responseMessageDisplay(this, quizBankAddResp)
        if (quizBankAddResp && quizBankAddResp.resp_status) {
          this.$emit("emitCloseChangeAppidModal")
        }
      }
      catch (err) {
        console.error("Exception occurred at quizBankEdit() and Exception:", err.message)
      }
    }
  }
}
</script>

<style scoped>
.alert-box {
  border-left: 4px solid var(--bs-primary);
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
